module.exports = __webpack_require__.p + "862cb275fccbd4e78e04756d323cf228.jpg";